import React from 'react';
import NewCard from '../../components/NewCard';

import { Text, TitleService } from '../../styles/typography';
import { Container, Row } from '../styles';
import { useTranslation } from 'react-i18next';
import StepText from '../../components/StepText';

const App: React.FC = () => {
  const { t } = useTranslation();
  return (
    <Container>
      <StepText currentStep={4} />

      <Text style={{ marginBottom: 10, marginTop: 0 }}>{t('integracao')}</Text>
      <TitleService style={{ marginBottom: 0 }}>
        {t('Qual')} <span>{t('Nivel')}</span> {t('Projeto')}
      </TitleService>
      <Text style={{ marginBottom: 10, marginTop: 0 }}>
        {t('Clique para avançar de etapa')}
      </Text>

      <Row>
        <NewCard
          title={t('Possuo a ideia, porém não tenho o detalhamento.')}
          name="nivelProjeto"
          value={t('Possuo a ideia, porém não tenho o detalhamento.')}
          path={'Urgencia'}
          description={''}
        />
        <NewCard
          title={t(
            'Já possuo um descritivo e gostaria de receber um orçamento.',
          )}
          name="nivelProjeto"
          value={t(
            'Já possuo um descritivo e gostaria de receber um orçamento.',
          )}
          path={'Urgencia'}
          description={''}
        />
        <NewCard
          title={t('Já comecei o desenvolvimento.')}
          name="nivelProjeto"
          value={t('Já comecei o desenvolvimento.')}
          path={'Urgencia'}
          description={''}
        />
        <NewCard
          title={t(' Procuro terceirizar minha equipe de desenvolvimento')}
          name="nivelProjeto"
          value={t(' Procuro terceirizar minha equipe de desenvolvimento')}
          path={'Urgencia'}
          description={''}
        />
        <NewCard
          title={t('Procuro uma equipe de sustentação')}
          name="nivelProjeto"
          value={t('Procuro uma equipe de sustentação')}
          path={'Urgencia'}
          description={''}
        />
      </Row>
    </Container>
  );
};

export default App;
